import axios from './axios-instance';

export function login(payload) {
  return axios.post('/unioncenter/web-background/account/login', payload);
}

export function loginByEncryption(payload) {
  return axios.post('/unioncenter/web-background/account/login-by-encryption', payload);
}

export function logout() {
  return axios.post('/unioncenter/web-background/account/logout');
}

export function editPwd(payload = {}) {
  return axios.post('/unioncenter/web-background/account/changeSelfPassword', payload);
}

export function loginByCode(code) {
  return axios.get('/unioncenter/account/login-by-qrcode', { params: { code } });
}

export function getUserInfo() {
  return axios.get('/unioncenter/token/userinfo');
}

export function getUserFunctions() {
  return axios.get('/unioncenter/web-background/role-function/get-user-functions');
}

// 获取租户信息
export function apiGetTenantDetail(params = {}) {
  return axios.get('/unioncenter/b/manage/tenant/detail', { params });
}

// 获取租户续约信息
export function apiGetTenantContract() {
  return axios.get('/brand-thirdremote/tenant-contract/alarm/message');
}
